import { useMemo } from 'react'

export const getMobileDetect = (userAgent: string) => {
  const isAndroid = (): boolean => Boolean(userAgent.match(/Android/i))
  const isIos = (): boolean => Boolean(userAgent.match(/iPhone|iPad|iPod/i))
  const isMobi = (): boolean => Boolean(userAgent.match(/Mobi/i))
  const isSSR = (): boolean => Boolean(userAgent.match(/SSR/i))
  const isMobile = (): boolean => Boolean(isAndroid() || isIos() || isMobi())
  const isDesktop = (): boolean => Boolean(!isMobile() && !isSSR())

  return {
    isMobile,
    isDesktop,
    isAndroid,
    isIos,
    isSSR,
  }
}

const useMobileDetect = () => {
  const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent
  return useMemo(() => getMobileDetect(userAgent), [userAgent])
}

export default useMobileDetect
